
import 'react-calendar/dist/Calendar.css';
import React from "react";
import './index.css'
import Navbar from "./components/Header/Navbar";
import Slider from "./components/Slider/Slider";
import image1 from "./assets/img_1.jpg";
import image2 from "./assets/img_2.jpg";
import image3 from "./assets/img_3.jpg";
import Footer from './components/Footer/Footer';
import { Route, Routes } from 'react-router-dom';
import Vazorat from './components/Page/Vazorat/Minister_2';
import MainContent from './components/MainContent/MainContent';
import Prezident from './components/Page/Prezident/Prezident';
import Heroeso from './components/Page/Tajikistan/Heroeso';
import DeputyMinisters from './components/Page/Vazorat/DeputyMinisters';
import Structure from './components/Page/Vazorat/Structure';
import HistoryMinistry from './components/Page/Vazorat/HistoryMinistry';
import Constitutions from './components/Page/Acts/Constitutions';
import Laws from './components/Page/Acts/Laws';
import Decisions_and_Оrders from './components/Page/Acts/Decisions_and_Оrders';
import Strategy_and_Programs from './components/Page/Acts/Strategy_and_Programs';
import Regulations from './components/Page/Acts/Regulations';
import Council_Decisions from './components/Page/Acts/Council_Decisions';
import Orders from './components/Page/Acts/Orders';
import Procedures_and_Rules from './components/Page/Acts/Procedures_and_Rules';
import Instructions from './components/Page/Acts/Instructions';
import Reactions from './components/Page/Reactions/Reaction';

export default function App() {

  return (
    <div>
      {/* // Header */}
      <Navbar />
      {/* -------------------------------------   {/* SLIDER */}
      <Slider images={[image1, image2, image3]}>
        <div className='   IcTVb header_text'
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }}
        >
          <h1 className="text-warnin text_slider">ВАЗОРАТИ МАОРИФ ВА ИЛМИ </h1>
          <h1 className="text-white text_slider">ҶУМХУРИИ ТОЧИКИСТОН</h1>
        </div>
      </Slider >


      <Routes>
        <Route path='/' element={<MainContent />} />
        <Route path='/vazir' element={<Vazorat />} />
        <Route path='/prezident-va-maorif' element={<Prezident />} />
        <Route path='/qahramononi-tojikiston' element={<Heroeso />} />
        <Route path='/muovinoni-vazir' element={<DeputyMinisters />} />
        <Route path='/sohtor' element={<Structure />} />
        <Route path='/tarihi-vazorat' element={<HistoryMinistry />} />
        <Route path='/konstitutsiyai-umurii-toikiston' element={<Constitutions />} />
        <Route path='/konunho' element={<Laws />} />
        <Route path='/karoru-farmono' element={<Decisions_and_Оrders />} />
        <Route path='/strategiya-va-barnomao' element={<Strategy_and_Programs />} />
        <Route path='/nizomnomao' element={<Regulations />} />
        <Route path='/karoroi-mushovara' element={<Council_Decisions />} />
        <Route path='/farmoisho' element={<Orders />} />
        <Route path='/tartibo' element={<Procedures_and_Rules />} />
        <Route path='/dasturo' element={<Instructions />} />
        <Route path='/vokunisho' element={<Reactions />} />


      </Routes>
      <Footer />
    </div>

  );
}
